import { chakra, forwardRef } from '@chakra-ui/system';
import type { HTMLChakraProps } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';

import { useContainerStyles } from './';
import { getClassName } from './className';

export type ContainerFooterProps = HTMLChakraProps<'div'>;

export const ContainerFooter = forwardRef<ContainerFooterProps, 'div'>(
  ({ children, className, ...props }, ref) => {
    const styles = useContainerStyles();

    return (
      <chakra.div
        ref={ref}
        __css={styles.containerFooter}
        className={cx(getClassName('footer'), className)}
        {...props}
      >
        {children}
      </chakra.div>
    );
  },
);
ContainerFooter.displayName = 'ContainerFooter';
